import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import {AdditionalColourchipsLoadingState} from "models/AdditionalColourchipsLoadingState"
import {ColourChipConfig} from "models/ProductSummary"
import {TextModel} from "../../models/Text"
import connect from "./connect"

interface ColourChip {
    itemNumber: string
    colourChipUrl: string
    linkUrl: string
    isSelected?: boolean
    colour?: string | null
    title: string
    price: string
    currencyCode: string
    altText: string
    department: string
}

export interface ColourChipsProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children?: JSX.Element
    colourchips?: ColourChip[]
    lazyloadColourchips?: boolean
    colourWayImageUrlBuilder: (val: string) => string
    text: TextModel
    title?: string
    numberOfAllColourways: number
    additionalColourchipsLoading: AdditionalColourchipsLoadingState
    realm: string
    fetchAdditionalColourchipsThunk: () => Promise<any>
    setAdditionalColourchipsLoading: (boolean) => void
    colourChipConfig: ColourChipConfig
    slideIndex: (index: number) => void
}

export const ColourChipsComponent = memo(
    ({
        children,
        templating,
        colourchips,
        lazyloadColourchips,
        colourWayImageUrlBuilder,
        text,
        additionalColourchipsLoading,
        numberOfAllColourways,
        realm,
        fetchAdditionalColourchipsThunk,
        setAdditionalColourchipsLoading,
        title,
        colourChipConfig,
        slideIndex,
    }: ColourChipsProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST as any)
        const props = {
            colourchips,
            lazyloadColourchips,
            colourWayImageUrlBuilder,
            text,
            additionalColourchipsLoading,
            numberOfAllColourways,
            realm,
            fetchAdditionalColourchipsThunk,
            setAdditionalColourchipsLoading,
            title,
            colourChipConfig,
            client: realm,
            slideIndex,
        }
        return <ComponentName {...props}>{children}</ComponentName>
    },
)
ColourChipsComponent.displayName = "ColourChipsComponent"

export default connect(ColourChipsComponent)
